var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Upload icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "upload-icon",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Approved---Quote---Desktop",
    transform: "translate(-397.000000, -3319.000000)",
    fill: "#0063C7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Button/Secondary-icon",
    transform: "translate(373.000000, 3304.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Upload-circle",
    transform: "translate(24.000000, 15.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9,0 C13.9705627,0 18,4.02943725 18,9 C18,13.9705627 13.9705627,18 9,18 C4.02943725,18 0,13.9705627 0,9 C0,4.02943725 4.02943725,0 9,0 Z M5.4845176,10.0106952 L4.42780749,10.0106952 L4.42780749,13.6684492 L13.6684492,13.6684492 L13.6684492,10.0106952 L12.6504733,10.0106952 L12.6504733,12.6589563 L5.4845176,12.6589563 L5.4845176,10.0106952 Z M8.99995099,2.88770053 L5.67914439,6.75133414 L8.21586349,6.75133414 L8.21586349,11.0695187 L9.7840385,11.0695187 L9.7840385,6.75143345 L12.3208556,6.75143345 L8.99995099,2.88770053 Z",
    id: "Shape"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.1be937a8d96359f45fd0cf79be6b0597.svg";
export { ForwardRef as ReactComponent };